export enum ErrorName {
  InvalidWorkspaceError = 'InvalidWorkspaceError',
  FieldValidationError = 'FieldValidationError',
  Neo4jError = 'Neo4jError',
  APIError = 'APIError',
  DuplicateFieldError = 'DuplicateFieldError'
}
